import React from 'react';

const ControlPanel = ({ onResetPreview, onCreateNewVersion, comparisonData }) => {
  const { added, removed, difficultyChanges } = comparisonData;

  return (
    <div className="control-panel">
      <div className="actions">
        <button onClick={onResetPreview}>Reset Preview</button>
        <button onClick={onCreateNewVersion}>Create New Version</button>
      </div>
      <div className="summary">
        <h3>Changes Summary</h3>
        <p>Puzzles added: {added.length}</p>
        <p>Puzzles removed: {removed.length}</p>
        <h4>Difficulty Changes:</h4>
        <ul>
          {Object.entries(difficultyChanges).map(([difficulty, change]) => (
            <li key={difficulty}>{difficulty}: {change > 0 ? '+' : ''}{change}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ControlPanel;